import * as React from 'react';
import classNames from 'classnames';
import { BaseProps, IntentStyle, ProgressStyle } from '../common/props';
import * as Classes from '../common/classes';

type Props = BaseProps & {
  intent?: IntentStyle;
  /**
   * Jedná se o progress kde neznáme hodnotu kolik už udělal? Tedy nekonečný progress? Při true je value ignorována.
   */
  infinite?: boolean;
  /**
   * @deprecated nově se používá size.
   */
  small?: boolean;
  size?: ProgressStyle;
  /**
   * Hodnota mezi 0 a 1 (včetně), která reprezentuje, jak daleko je progress.
   * Hodnoty pod 0 nebo nad 1 budou interpretovány jako 0 nebo 1.
   * Pokud tuto vlastnost vynecháte, výsledkem bude "neurčitý" ukazatel průběhu, který vyplní celý pruh, stejné jako když se uvede infinite.
   */
  value?: number;
};

export class ProgressBar extends React.PureComponent<Props> {
  render() {
    const {
      className,
      style,
      title,
      value,
      infinite,
      intent,
      small,
      size,
      children,
    } = this.props;

    const animate = true;

    const cls = classNames(className, Classes.PROGRESS_BAR, {
      [Classes.PROGRESS_BAR_SMALL]: small ?? size === 'small',
      [Classes.PROGRESS_BAR_LARGE]: size === 'large',
      [Classes.PROGRESS_BAR_INFINITE]: !!infinite || value === undefined,
      [Classes.PROGRESS_BAR_INFINITE_AN]: animate,
      [Classes.INTENT_PRIMARY]: intent === 'primary',
      [Classes.INTENT_DANGER]: intent === 'danger',
      [Classes.INTENT_SUCCESS]: intent === 'success',
      [Classes.INTENT_WARNING]: intent === 'warning',
    });

    let realWidth: number;
    if (value !== undefined && !infinite) {
      realWidth = value * 100;
    } else {
      realWidth = 100;
    }

    return (
      <div className={classNames(cls)} style={style} title={title}>
        <div
          style={{ width: `${realWidth}%` }}
          className={Classes.PROGRESS_BAR_METER}
        />
        <div className={Classes.PROGRESS_BAR_CONTENT}>{children}</div>
      </div>
    );
  }
}
